import { curry, compose, defaultTo } from 'ramda';
import parseCode from './parseCode.js';
import findCodeByTile from './findCodeByTile.js';

function getPKeyByTile(e,o){return compose(parseCode.prop("pKey"),defaultTo(""),findCodeByTile(e))(o)}var getPKeyByTile$1 = curry(getPKeyByTile);

export { getPKeyByTile$1 as default };
//# sourceMappingURL=getPKeyByTile.js.map
